import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { SmartTeamsLocation } from '@nsc/smartteams-shared/db/SmartTeamsLocation.js';

@Entity()
export class SmartTeamsAvailability extends MongoEntity {
  static override _class = 'SmartTeamsAvailability';
  static override _collectionName = 'smartteams_availabilities';

  @validate(nonOptional())
  @Field(() => String)
  fieldEngineerId: Maybe<string>;

  @validate(nonOptional())
  @Field(() => Date)
  date: Maybe<Date>;

  @validate(nonOptional())
  @Field(() => String)
  startTime: Maybe<string>; // Format: "HH:mm"

  @validate(nonOptional())
  @Field(() => String)
  endTime: Maybe<string>; // Format: "HH:mm"

  @Field(() => SmartTeamsLocation)
  location: Maybe<SmartTeamsLocation>;

  @Field(() => Boolean, { default: v => v ?? true })
  useDefaultLocation: Maybe<boolean>;

  @Field(() => String)
  notes: Maybe<string>;

  @Field(() => String)
  createdBy: Maybe<string>;

  @Field(() => Date)
  deletedAt: Maybe<Date>;

  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;
}
